import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ACL } from '../../../../constants'
import PushConfirmation from './PushConfirmation'

type ContentPushConfirmationProps = {
    devicesCount: number
    isOpen: boolean
    storeCount: number
    pushToAllDevices: () => void
    percentage?: number
} 

export default function ContentPushConfirmation({
    devicesCount,
    isOpen,
    storeCount,
    percentage,
    pushToAllDevices,
}: ContentPushConfirmationProps) {
    const { t } = useTranslation()

    return (
        <PushConfirmation
            acl={ACL.CONTENT_PUSH}
            confirmationMessage={t('content-push-confirmation', {
                context: 'body',
                count: devicesCount,
                stores: storeCount,
            })}
            header={t('content-push-confirmation', {
                context: 'title',
            })}
            inProgressMessage={t('message-content-update_body', {
                context: 'other',
                count: devicesCount,
            })}
            percentage={percentage}
            pushToAllDevices={pushToAllDevices}
        >
            <FontAwesomeIcon
                icon="cloud-download-alt"
                title={t('content-push-description')}
                style={{ marginLeft: '5px', float: isOpen ? 'right' : 'none' }}
            />
        </PushConfirmation>
    )
}